<template>
  <div class="coupon-area" @click.stop.prevent="viewCardDetail">
    <div
      v-if="showType === 2"
      class="coupon-fix-item f v fvc"
      :class="linebgc"
    >
      <div class="area-header disFlex fc fvc">
        <div class="head-title">{{ cardInfo.name }}</div>
      </div>
      <div class="area-body disFlex">
        <div class="coupon-box f fc">
          <div
            class="coupon-item"
            v-for="coupon in couponList"
            :key="coupon.id"
          >
            <div class="disFlex vertical fvc">
              <img
                src="https://j.weizan.cn/youxiang/coupon-bg2.png"
                class="coupon-bg"
              />
              <!-- <div class="coupon-bt"></div> -->
            </div>
            <div class="coupon-detail disFlex vertical fc">
              <div class="coupon-title clamp1">{{ coupon.name }}</div>
              <div class="coupon-price">
                <span>{{ coupon.maxAmount }}</span>
                <span class="price-unit">元</span>
              </div>
              <div class="coupon-tag">- 优惠券 -</div>
              <div class="coupon-info" v-if="coupon.rule">满{{ coupon.rule[0][0] }}可用</div>
              <div class="op-btn">立即购买</div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-footer disFlex Flex-center Flex-between">
        <div>已售{{ cardInfo.sales }}件</div>
        <div>
          查看全部优惠内容
          <div class="next-page"></div>
        </div>
      </div>
      <div class="act-info f v" v-if="cardInfo.prompt">
        <div class="info-title">活动说明</div>
        <div class="info-content html-content" v-html="cardInfo.prompt"></div>
      </div>
      <div class="get-coupon-btn" :class="fontcolor" v-if="!buy">
        {{ cardInfo.seckillPrice }}获得全部优惠券
      </div>
      <div class="get-coupon-btn" v-else>立即使用</div>
    </div>
    <div class="coupon-single-item" v-else>
      <img
        src="https://j.weizan.cn/youxiang/coupon-single-item-bg2.png"
        class="coupon-single-item-bg"
      />
      <div class="f fc fbt">
        <div class="info f v">
          <div class="name">{{ cardInfo.name }}</div>
          <div class="detail">成功购买可进入"我的" - "优惠券"中查看</div>
        </div>
        <div class="price f v fvc" v-if="cardInfo.maxAmount > 0">
          <div class="price-detail f fc">
            <div class="unit">￥</div>
            <div>{{ cardInfo.maxAmount }}</div>
          </div>
        </div>
      </div>
      <div class="tag" v-if="cardInfo.maxAmount > 0">最高减免</div>
      <div class="tip f fc fbt">
        <div class="number">已售：{{ cardInfo.sales }}件</div>
        <div class="seckill f fc">
          {{ cardInfo.seckillPrice }}秒杀
          <div class="next-page"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardInfo: {
      type: Object,
      default: {},
    },
    couponList: {
      type: Array,
      default: [],
    },
    showType: {
      type: Number,
      default: 1,
    },
    buy: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "blue",
    },
  },
  data() {
    return {
      linebgc: {},
      fontcolor: {},
    };
  },
  methods: {
    viewCardDetail() {
      this.$emit("viewCardDetail");
    },
  },
  created() {
    if (this.color == "red") {
      this.linebgc.red_linear = true;
      this.fontcolor.red_c = true;
    } else if (this.color == "purple") {
      this.linebgc.purple_linear = true;
      this.fontcolor.purple_c = true;
    } else if (this.color == "green") {
      this.linebgc.green_linear = true;
      this.fontcolor.green_c = true;
    } else if (this.color == "yellow") {
      this.linebgc.yellow_linear = true;
      this.fontcolor.yellow_c = true;
    }
  },
};
</script>

<style lang="less" scoped>
.coupon-area {
  .red_linear {
    background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
  }
  .red_bgc {
    background: #b80000 !important;
  }
  .red_bgc_light {
    background: rgba(184, 0, 0, 0.6) !important;
  }
  .red_c {
    color: #b80000 !important;
  }

  .purple_linear {
    background: linear-gradient(134deg, #7634FA, #3F10EA) !important;
  }
  .purple_c {
    color: #3B13A7 !important;
  }
  .green_linear {
    background: linear-gradient(134deg, #227B79, #124943) !important;
  }
  .green_c {
    color: #14413A !important;
  }
  .yellow_linear {
    background: #3339DB !important;
    border: 2px solid #000000 !important;
  }
  .yellow_c {
    color: #ffffff !important;
  }

  .coupon-fix-item {
    width: 345px;
    margin: 20px auto;
    background: linear-gradient(
      90deg,
      rgba(0, 37, 93, 1),
      rgba(0, 64, 161, 1),
      rgba(0, 37, 93, 1)
    );
    border: 1px solid rgba(255, 209, 143, 1);
    border-radius: 5px;
    overflow: hidden;
    .area-header {
      width: 100%;
      padding: 20px 15px;
      // background: linear-gradient(
      //   90deg,
      //   rgba(0, 37, 93, 1),
      //   rgba(0, 64, 161, 1),
      //   rgba(0, 37, 93, 1)
      // );

      .head-title {
        font-size: 25px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(255, 209, 143, 1);
        line-height: 30px;
        text-align: center;
      }
    }
    .area-body {
      width: 100%;
      overflow-x: scroll;
      .coupon-box {
        padding-left: 20px;
      }
      .coupon-item {
        position: relative;
        width: 90px;
        height: 104px;
        margin: 0 15px 0 0;
        .coupon-bg {
          width: 90px;
          height: 104px;
        }
        // .coupon-bt {
        //   width: 137px;
        //   height: 12px;
        //   background: rgba(0, 27, 68, 1);
        //   border-radius: 50%;
        //   position: relative;
        //   top: -6px;
        //   z-index: -1;
        // }
        .coupon-detail {
          width: 90px;
          height: 104px;
          position: absolute;
          top: 0;
          left: 0;
          .coupon-title {
            width: 52px;
            text-align: center;
            font-size: 12px;
            font-family: PingFang SC;
            line-height: 17px;
            padding: 0 5px;
            font-size: 10px;
            color: rgba(255, 255, 255, 1);
          }
          .coupon-price {
            font-size: 26px;
            font-family: DIN;
            font-weight: bold;
            color: rgba(255, 66, 0, 1);
            margin: 4px 0 2px;
          }
          .price-unit {
            font-size: 12px;
            display: inline-block;
          }
          .coupon-tag {
            font-size: 10px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(255, 66, 0, 1);
          }
          .coupon-info {
            font-size: 10px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 6px;
            margin-top: 8px;
          }
          .op-btn {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
    .area-footer {
      margin-top: 20px;
      width: 100%;
      padding: 0 16px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 209, 143, 1);
      line-height: 24px;
      .next-page {
        width: 6px;
        height: 6px;
        border-top: 2px solid #ffd18f;
        border-right: 2px solid #ffd18f;
      }
    }
    .get-coupon-btn {
      width: 210px;
      height: 44px;
      background: rgba(255, 209, 143, 1);
      border: 2px solid;
      // box-shadow: 0px 4px 5px 0px rgba(0, 27, 68, 1);
      border-radius: 22px;
      line-height: 44px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(0, 48, 120, 1);
      line-height: 44px;
      margin: 20px auto;
      text-align: center;
    }
    .next-page {
      color: #ffd18f;
      width: 6px;
      height: 6px;
      border-top: 2px solid #ffd89f;
      border-right: 2px solid #ffd89f;
      margin-left: 5px;
      margin-top: 2px;
    }
    .act-info {
      width: 100%;
      border-radius: 5px;
      padding: 11px;
      box-sizing: border-box;
      .info-title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 10px;
      }
      .info-content {
        overflow-x: hidden;

        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
.coupon-single-item {
  width: 335px;
  height: 103px;
  position: relative;
  margin: 20px auto;
  .coupon-single-item-bg {
    width: 335px;
    height: 103px;
  }
  .info {
    width: 66%;
    line-height: 16px;
    position: absolute;
    left: 15px;
    top: 18px;
    .name {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(141, 81, 22, 1);
      margin-bottom: 7px;
    }
    .detail {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(119, 66, 14, 1);
      opacity: 0.7;
    }
  }
  .tag {
    width: 68px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    background: rgba(141, 81, 22, 0.1);
    border-radius: 0px 4px 0px 4px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(141, 81, 22, 1);
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .price {
    position: absolute;
    right: 0;
    top: 25px;
    width: 90px;
    .price-detail {
      margin-top: 10px;
      margin-right: 13px;
      font-size: 24px;
      font-family: DIN;
      color: rgba(141, 81, 22, 1);
    }
    .unit {
      font-size: 15px;
      font-family: DIN;
      font-weight: bold;
      color: rgba(141, 81, 22, 1);
    }
  }

  .tip {
    position: absolute;
    bottom: 10px;
    left: 15px;
    width: 91%;
    font-size: 12px;
  }
  .number {
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(119, 66, 14, 0.7);
    margin-top: 10px;
  }
  .seckill {
    font-size: 14px;
    font-family: PingFang SC;
    color: rgba(255, 216, 159, 1);
    padding: 0 10px;
    line-height: 25px;
    height: 25px;
    background: rgba(141, 81, 22, 1);
    border-radius: 13px;
  }
}
</style>